import Vue from "vue";
const api_path = "/sales";

export async function index(options, filter, advanced_filters = {}) {
  const { sortBy, sortDesc, page, itemsPerPage } = options;

  const response = await Vue.prototype.$http.get(`${api_path}`, {
    params: {
      orderBy: sortBy[0] ? sortBy[0] : "",
      sortDesc: sortDesc[0] ? sortDesc[0] : "",
      page,
      perPage: itemsPerPage,
      filter,
      ...advanced_filters
    }
  });

  return response.data;
}

export async function store(payload) {
  const response = await Vue.prototype.$http.post(`${api_path}`, payload);

  return response.data;
}

export async function show(numero) {
  const response = await Vue.prototype.$http.get(`${api_path}/${numero}`);

  return response.data;
}

export async function update(id, payload) {
  const response = await Vue.prototype.$http.put(`${api_path}/${id}`, payload);

  return response.data;
}

export async function destroy(id) {
  const response = await Vue.prototype.$http.delete(`${api_path}/${id}`);

  return response.data;
}

export async function cancel(id) {
  const response = await Vue.prototype.$http.post(`${api_path}/${id}/cancel`);

  return response.data;
}

export async function approve(id, payload) {
  const response = await Vue.prototype.$http.post(
    `${api_path}/${id}/approve`,
    payload
  );

  return response.data;
}

export async function finish(payload) {
  const response = await Vue.prototype.$http.post(
    `${api_path}/finish`,
    payload
  );

  return response.data;
}

export async function deleteProduto(produto_venda_id, payload) {
  const response = await Vue.prototype.$http.delete(
    `produto_venda/${produto_venda_id}`
  );

  return response.data;
}
